import { configureStore } from "@reduxjs/toolkit"
import reduktor from "./reduktor"
//import { composeWithDevTools } from "redux-devtools-extension"

const magazyn =  configureStore ({reducer:reduktor},window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

export default magazyn
export { zapisKonkurs} from './kreatorAkcji'